<div *ngIf="apicallcompleted" class="container-fluid" class="my-3 mx-5">
    <div class="row ">
        <div class="col-12">
            <div class="alert alert-success" role="alert" *ngIf="success">
                <h4 class="alert-heading">Token Verified Succussfully!!</h4>
                
                <p class="mb-0">{{message}}</p>
            </div>
            <div class="alert alert-success" role="alert" *ngIf="!success">
                <h4 class="alert-heading">Failed to Confirm the Token!!</h4>
                <p>Invalid Token</p>

            </div>
        </div>
    </div>
    
    </div>